export const environment = {
  production: false,
  env: 'Ambiente Pruebas',
  apiUrl: 'https://emadrmxapitest.clavisco.com/',
  reportManagerUrl: 'https://rptmanagertest.clavisco.com/',
  padronUrl: 'https://api.hacienda.go.cr/fe/'
};
  